<app-inspection-table-header
  [allChecked]="allGoodsIsChecked()"
  (filterValues)="onFiltersApply($event)"
  (onSelectAll)="selectAllGoods()">
</app-inspection-table-header>
<app-table-items>
  <app-table-item *ngFor="let good of data; let odd = odd" [isOdd]="odd" class="item">
      <app-table-column name="check" (click)="selectGood(good)" styleType="old">
        <div content>
          <mat-checkbox *ngIf="good.state === PalletState.RECEIVED"
            [checked]="selectedGoodsTagRfids.has(good.tagRfid)" (click)="$event.preventDefault()">
          </mat-checkbox>
        </div>
      </app-table-column>

      <app-table-column name="date" (click)="emitClicked(good, 0)" styleType="old" size="small">
        <div content class="quantity-wrapper">
          {{formatTimestamp(good.crateEntryEventTimestamp) || '---'}}
        </div>
      </app-table-column>

      <app-table-column name="position" (click)="emitClicked(good, 0)" styleType="old" size="small">
        <div content class="quantity-wrapper">
          {{getGroundPositionAlias(good)}}
        </div>
      </app-table-column>

      <app-table-column name="document" (click)="emitClicked(good, 0)" size="intermediate" styleType="old">
        <div content class="quantity-wrapper">
          {{good.inOrderNumber || '---'}}
        </div>
      </app-table-column>

      <app-table-column name="user" (click)="emitClicked(good, 0)" styleType="old">
        <div content class="quantity-wrapper">
          {{getUserName(good.crateEntryEventUser)}}
        </div>
      </app-table-column>

      <app-table-column name="product" (click)="emitClicked(good, 0)" styleType="old">
        <div content class="product-name-wrapper">
          <span *ngFor="let product of good.skuGroups">{{ product.sku || '---'}}</span>
          <span *ngIf="!good.skuGroups || good.skuGroups.length === 0">---</span>
        </div>
      </app-table-column>

      <app-table-column name="product" (click)="emitClicked(good, 0)" styleType="old">
        <div content class="product-name-wrapper">
          <span *ngFor="let product of good.skuGroups">{{ product.name || '---'}}</span>
          <span *ngIf="!good.skuGroups || good.skuGroups.length === 0">---</span>
        </div>
      </app-table-column>

      <app-table-column name="family" (click)="emitClicked(good, 0)" styleType="old">
        <div content class="product-name-wrapper">
          <span *ngFor="let product of good.skuGroups">{{ product.description || '---'}}</span>
          <span *ngIf="!good.skuGroups || good.skuGroups.length === 0">---</span>
        </div>
      </app-table-column>

      <app-table-column name="quantity" (click)="emitClicked(good, 0)" styleType="old">
        <div content class="quantity-wrapper">
          <span *ngFor="let product of good.skuGroups">{{ (product.quantity | number:'1.0-0':'pt-BR') || '---'}}</span>
          <span *ngIf="!good.skuGroups || good.skuGroups.length === 0">---</span>
        </div>
      </app-table-column>

      <app-table-column name="messages" (click)="emitClicked(good, 4)" styleType="old">
        <span content>
          <i *ngIf="!good.commentsQty" class="uil uil-comment"></i>
          <i *ngIf="good.commentsQty" class="uil uil-comment-lines"></i>
          {{ (good.commentsQty | number:'1.0-0':'pt-BR') }}
        </span>
      </app-table-column>

      <app-table-column name="rfid" styleType="old">
        <div content>
          <button mat-raised-button class="primary-2" (click)="onTaskRequest.emit(good)"
          [ngClass]="{'white': good.inspectionState === 'AWAITING_STORAGE' || good.inspectionState === 'IN_PROCESS'}">
          <img *ngIf="good.inspectionState === 'AWAITING_STORAGE'" src="assets/icons/forklift-1.svg">
          <img *ngIf="good.inspectionState === 'IN_PROCESS'" src="assets/icons/forklift-1.svg">
          {{ getButtonText(good) }}
        </button>
        </div>
      </app-table-column>
  </app-table-item>
</app-table-items>